// src/components/card/ui.js
const SCALE = 0.78; // 全站字級略縮（手機不擠爆）；要再小可調 0.75
const f = n => Math.round(n * SCALE);

export const fonts = {
  title: { fontSize: f(60), fontWeight: 700, color: '#1f1f1f', letterSpacing: 1.5,
           fontFamily: "CSong3HK, CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
  label: { fontSize: f(20), color: '#6b5b4b',
           fontFamily: "CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
  label2: { fontSize: f(19), color: '#6b5b4b',
           fontFamily: "CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
  labelinfo: { fontSize: f(19), color: '#6b5b4b',
           fontFamily: "CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
  big:   { fontSize: f(40), fontWeight: 700, color: '#1c1c1c',
           fontFamily: "CSong3HK, CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
  // 英數/數字用 MarcellusSC
  val:   { fontSize: f(36), fontWeight: 700, color: '#111',
           fontFamily: "MarcellusSC, CSong3HK, serif" },
  info:  { fontSize: f(22), color: '#282828',
           fontFamily: "CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
  small: { fontSize: f(18), color: '#6b6b6b',
           fontFamily: "CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
  date:  { fontSize: f(18), color: '#5e3a1a',
           fontFamily: "CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif" },
};

// 分頁標籤（白字，避免換行）
export const tabFont = {
  fontSize: 12, // 固定像素，避免小裝置折行
  fontWeight: 700,
  color: '#fff',
  whiteSpace: 'nowrap',
  lineHeight: 1,
  letterSpacing: 0.5,
  textShadow: '0 1px 2px rgba(0,0,0,.35)',
  fontFamily: "CreamFont, 'PingFang TC', 'Microsoft JhengHei', serif",
};

// 三格下方的小註解（POINT / PASS / BALANCE）
export const kicker = {
  fontSize: f(18),
  color: '#6b5b4b',
  letterSpacing: 1,
  fontFamily: "MarcellusSC, CSong3HK, serif",
};

// 置中錨點（舊）
export const place = (px, x, y, extra = {}) => ({
  position: 'absolute',
  left: px(x),
  top: px(y),
  transform: 'translate(-50%, -50%)',
  whiteSpace: 'nowrap',
  ...extra,
});

// 左上錨點（新）
export const placeTL = (px, x, y, extra = {}) => ({
  position: 'absolute',
  left: px(x),
  top: px(y),
  whiteSpace: 'nowrap',
  ...extra,
});

export const benefitsByLevel = (level='') => {
  const s = String(level || '');
  if (/月會員/.test(s))     return <>平日免費進場/單點八折<br/>假日資深價入場</>;
  if (/資深年會員/.test(s)) return <>資深價入場</>;
  if (/年會員/.test(s))     return <>年會員價入場</>;
  if (/一般顧客/.test(s))   return <>一般顧客入場</>;
  return <>員工福利單點六折<br/>平日免費/假日資深價進場</>;
};

export const formatDate = (iso) => {
  if (!iso) return '-';
  const d = (iso.split?.('T')[0] || iso).replaceAll('-', '/');
  return d;
};

// Info 右欄用（多行）
export const ValCell = {
  ...fonts.info,
  gridColumn: '2 / -1',
  minWidth: 0,
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
  lineHeight: 1,
};
